export default __webpack_public_path__ + "ad8f68a8d0982dd963c980de13e5750b.svg";